var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb80(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.01,9.64h2.97v4.19h4.03v-4.19h2.98v10.73h-2.98v-4.07h-4.03v4.07h-2.97v-10.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.49,9.14v1.42L29.65,1.39c.35-.23.45-.69.23-1.05-.23-.35-.69-.45-1.05-.23l-9.02,9.02h.67Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.65,28.61l-9.16-9.16v1.42h-.67l9.02,9.02c.13.08.27.12.41.12.25,0,.49-.12.64-.35.23-.35.12-.82-.23-1.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9.51,9.14h.67L1.16.12C.81-.11.35,0,.12.35-.11.7,0,1.17.35,1.39l9.16,9.16v-1.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9.51,20.86v-1.42L.35,28.61c-.35.23-.45.69-.23,1.05.14.23.39.35.64.35.14,0,.28-.04.41-.12l9.02-9.02h-.67Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m24.19,22.44c1.65-2.03,2.64-4.62,2.64-7.44s-.99-5.4-2.64-7.44l-1.13,1.13c1.37,1.74,2.19,3.93,2.19,6.31s-.82,4.57-2.19,6.31l1.13,1.13Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m15,4.75c2.38,0,4.56.82,6.31,2.19l1.13-1.13c-2.03-1.65-4.62-2.64-7.44-2.64s-5.4.99-7.44,2.64l1.13,1.13c1.74-1.37,3.93-2.19,6.31-2.19Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m5.81,7.56c-1.65,2.03-2.64,4.62-2.64,7.44s.99,5.4,2.64,7.44l1.13-1.13c-1.37-1.74-2.19-3.93-2.19-6.31s.82-4.57,2.19-6.31l-1.13-1.13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m15,25.25c-2.38,0-4.56-.82-6.31-2.19l-1.13,1.13c2.03,1.65,4.62,2.64,7.44,2.64s5.4-.99,7.44-2.64l-1.13-1.13c-1.74,1.37-3.93,2.19-6.31,2.19Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m0,15c0,3.73,1.23,7.27,3.33,9.92l1.13-1.13c-1.82-2.35-2.87-5.48-2.87-8.79s1.06-6.44,2.87-8.79l-1.13-1.13C1.23,7.73,0,11.27,0,15Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m5.05,26.7c.13.08.27.13.41.13.22,0,.44-.09.6-.27.23-.27.24-.65.06-.93l-1.08,1.08Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m6.06,3.44c-.26-.3-.69-.34-1.01-.14l1.07,1.07c.18-.29.17-.66-.06-.93Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m30,15.07c0-3.76-1.24-7.31-3.36-9.96l-1.12,1.12c1.84,2.35,2.9,5.49,2.9,8.83s-1.04,6.41-2.84,8.75l1.13,1.13c2.08-2.64,3.3-6.17,3.3-9.88Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m24.92,3.33s-.05-.05-.07-.07c-.34-.28-.84-.23-1.12.11-.27.32-.23.79.08,1.08l1.11-1.11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m23.91,26.65c.16.18.38.28.6.28.17,0,.34-.06.49-.17l-1.1-1.1c-.23.29-.24.7.01,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb80);
export default __webpack_public_path__ + "static/media/FB80.bacce2012c7a83cc035d93d8aa216d36.svg";
export { ForwardRef as ReactComponent };